import(/* webpackMode: "eager" */ "/home/runner/_work/ecom-velocity-app/ecom-velocity-app/src/product-listing-page/src/app/global-error.tsx");
